import PropTypes from 'prop-types';
import React from 'react';
import { Wrapper, Container, Header, Body, Footer, Title, Button } from './styles';
import { MESSAGE } from 'Common';

const MessageBox = ({ message, setMessage }) => {

    function closeBox() {
        if (!!message?.handleClose) { setMessage({}); message.handleClose(); }
        else { setMessage({}); }
    }

    return (
        <>
            {!!message && message?.contents !== undefined && message.contents.length > 0 ? (
                <Wrapper>
                    <Container>
                        <Header msgType={message.type}>
                            <Title>{message.type === MESSAGE.ERROR ? 'エラー' : (message.type === MESSAGE.INFO ? '情報' : '警告')}</Title>
                        </Header>
                        <Body msgType={message.type}>
                            {message.contents.map((msg, index) => {
                                return (
                                    <p key={index} style={{ whiteSpace: "pre-line" }}>{msg}</p>
                                )
                            })}
                        </Body>
                        <Footer>
                            {!message?.isYesNo && (<Button onClick={() => { closeBox(); }}>閉じる</Button>)}
                            {!!message?.isYesNo && (
                                <>
                                    <Button onClick={() => { closeBox(); }}>いいえ</Button>
                                    <Button className='btn-yes' style={{ marginLeft: "12px" }}
                                        onClick={() => {
                                            if (!!message.handleYes) message.handleYes();
                                            closeBox();
                                        }}
                                    >はい</Button>
                                </>
                            )}
                        </Footer>
                    </Container>
                </Wrapper>
            ) : <></>}
        </>
    )
}


export default MessageBox
